import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private ws: PostmethodService) { }

  getToDo() {
    return this.ws.wsGet(environment.baseUrl + "/lead/todoSummary");
  }
}
